// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","light-grey":"#d4d4d4","grey":"#707070","white":"#ffffff","dark-red":"#a30000","red":"#e40000","tag":"_3OB_vPQYOFHhL9GtBhP6Mn","large":"_2TUHe103uo_NgMnEMeGHF_","small":"_3p1NYjKSa1P1BGj8bBik_6","active":"ER1ka-EevF2LKCzskvWZV","disable":"_3NsaAB4zQvYb6knNAF9g3c","closed":"_2UHv-o_53LS3ovXP77zbIo","secondary":"_25VBKdWsx8xBk39ocTvMLG"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tags/Tag/Tag.css
// module id = 1167
// module chunks = 0